import React, {
    useState,useEffect
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { DatePicker, TimePicker, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { PMPList, SavePmpReSchedule, GetTechnicianPMPList } from './actions/pmpService';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { useLocation } from 'react-router';
import dayjs from 'dayjs';
const { Option } = Select;


// class PMPVendorReschedule extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             title: "Preventive Maintenance Planner Reschedule",
//         }
//     }
//     _doNavToPMPAdd = () => {
//         this.props.navigate("/PMPVendorList");
//     }
//     render() {
//         return (
//             <div className="wrapper">
//                 <Header title={this.state.title} />
//                 <Menu1 />
//                 <div className='content-wrapper'>
//                     <section className='content top-space'>
//                         <div className="m-panel">
//                             <div className="m-panel__body">
//                                 <div className="row">
//                                     <div className="col-md-4">
//                                     <div className="form-group">
//                                                 <label htmlFor='exampleInput'>Date & Time*</label>
//                                                 <DatePicker showTime={{ format: 'hh:mm a' }} use12Hours
//                                                    placeholder="Select Date & Time" format="DD-MM-YYYY hh:mm a" className="form-control"
//                                                 />
//                                             </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor="exampleInput">Name*</label>
//                                             <Select className="form-control "
//                                                     placeholder="-- Please Select Technician--">
//                                                     <Option value='1'>Technician 1</Option>
//                                                     <Option value='2'>Technician 2</Option>
//                                                     <Option value='3'>Technician 3</Option>
//                                                     <Option value='4'>Technician 4</Option>
//                                                     <Option value='5'>Technician 5</Option>   
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Add comment*</label>
//                                             <input type="text" className="form-control" />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-md-12 text-right">
//                                 <div className="m-page__button top-space">
//                                     <button type='button' onClick={this._doNavToPMPAdd} className='btn muted-button  deca-btn-orange'>Back</button>
//                                     <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//                 <Footer />
//             </div>
//         )
//     }
// }

// export default PMPVendorReschedule;


function PMPVendorReshedule() {
    const title = "Preventive Maintenance Planner Reschedule"
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation();
    const [isSubmit, setIsSubmit] = useState(false)
    const pmpData = useSelector(state => state.pmpList)
    const TechnicianDetails = useSelector(state => state?.pmpList?.TechnicianDetails?.TechnicianList)
    // const rescheduleData = JSON.parse(localStorage.getItem('rescheduleData'))
    const {fedid, pmpid, technician, comments} = location.state.scheduleData
    const [scheduleData, setScheduleData] = useState({
        fedid:fedid,
        pmpid:pmpid,
        resheduled_type:0,
        technician:technician,
        newpmpstartdate:'',
        comments:comments
    })
    // console.log(scheduleData,'scheduleData');
    const _doNavToPMPAdd = () => {
        navigate("/PMPVendorList");
    }
    function disabledDate(current) {
        return current && current < dayjs().endOf('day');
      }
    const handleSubmit = () =>{
        setIsSubmit(true);
        if(scheduleData.newpmpstartdate=='')return;
        else if (scheduleData.technician=='')return;
        else if (scheduleData.comments=='') return;
        scheduleData.newpmpstartdate = scheduleData.newpmpstartdate.endsWith(' pm') ?scheduleData.newpmpstartdate.replace(' pm',''):scheduleData.newpmpstartdate.replace(' am','');
        console.log(scheduleData,'rescheduleData')
        dispatch(SavePmpReSchedule(scheduleData))
        setIsSubmit(false)
    }
    useEffect(()=>{
        dispatch(GetTechnicianPMPList())
    },[])
    // console.log(location,'this.props')
    return (
        <div className="wrapper">
                <Header title={title} />
                <Menu1 />
                {pmpData.modalOpen ? (
                <MessageBox
                 message={pmpData.message}
          // signout={"false"}
                onClose={()=>{
                _doNavToPMPAdd();
                dispatch(PMPList(true))
                }}
          
                 />

                 ) : null}
                <div className='content-wrapper'>
                    <section className='content top-space'>
                        <div className="m-panel">
                            <div className="m-panel__body">
                                <div className="row">
                                    <div className="col-md-4">
                                    <div className="form-group">
                                                <label htmlFor='exampleInput'>Date & Time*</label>
                                                {/* <DatePicker showTime={{ format: 'hh:mm a' }} use12Hours
                                                   placeholder="Select Date & Time" format="DD-MM-YYYY hh:mm a" className="form-control"
                                                /> */}
                                                <DatePicker showTime={{ format: 'hh:mm a' }} use12Hours
                                                disabledDate ={disabledDate}
                                                onChange={(date, dateString) => setScheduleData({...scheduleData,newpmpstartdate:dateString})}
                                                placeholder="Select Date & Time" format="YYYY-MM-DD hh:mm:ss a" className="form-control"
                                            />
                                            {scheduleData.newpmpstartdate =='' && isSubmit == true && <span style={{color:'red'}}>Please Select Your new Pmp Schedule Date</span>}
                                            </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInput">Technician Name*</label>
                                            <Select className="form-control "
                                                    placeholder="-- Please Select Technician--"
                                                    value ={scheduleData.technician}
                                                    onChange={(value)=>setScheduleData({...scheduleData,technician:value})}
                                                    >
                                                    {
                                                            TechnicianDetails?.map((element,index)=>{
                                                                return(
                                                                    <Option key={index} value={element.technician_id}>{element.technician_name}</Option>
                                                                )
                                                            })
                                                        }  
                                            </Select>
                                            {scheduleData.technician =='' && isSubmit == true && <span style={{color:'red'}}>Please Select Your Technician</span>}

                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Add comment*</label>
                                            <input type="text" className="form-control" maxLength="1000" value={scheduleData.comments} onChange={(e)=>setScheduleData({...scheduleData,comments:e.target.value.replace(/[^\w\s]/gi, "")})}/>
                                            {scheduleData.comments =='' && isSubmit == true && <span style={{color:'red'}}>Please Enter Comments</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <div className="m-page__button top-space">
                                    <button type='button' onClick={_doNavToPMPAdd} className='btn muted-button  deca-btn-orange'>Back</button>
                                    <button type='button' className='btn btn-secondary deca-btn-yellow' onClick={handleSubmit}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
    )
}

export default PMPVendorReshedule
